import { AccessControlManager } from "../_resources/accesscontrol-manager.js";
import { getSupaACLOwnedResources } from "../_resources/supa-helpers.js";
import { holdButton } from "../_resources/ui-library.js";
import "./ByResourceView.styl";

export default class ByResourceView {
  constructor({ dom, message }) {
    this.dom = dom;
    this.message = message;
    this.container = null;
    this.accessData = [];
  }

  async loadAccessData() {
    // Load all ACL data for resources where user is owner
    const { ok, error } = await getSupaACLOwnedResources();
    
    if (error) {
      console.error('Error loading access data:', error);
      this.message.bad(error);
      return { error };
    }
    
    this.accessData = ok;
    return { data: this.accessData };
  }

  async render() {
    const container = this.dom;
    this.container = container;
    
    container.html('');
    container.append('h1').text('Access Audit by Resource');
    
    const { error } = await this.loadAccessData();
    if (error) return;
    
    // Group by scope, then by resource
    const grouped = this.groupByScope(this.accessData);
    
    // Sort scopes in specific order: page, site, dataset, server
    const scopeOrder = ['page', 'site', 'dataset', 'server'];
    const sortedScopes = Object.keys(grouped).sort((a, b) => {
      const indexA = scopeOrder.indexOf(a);
      const indexB = scopeOrder.indexOf(b);
      if (indexA === -1 && indexB === -1) return a.localeCompare(b);
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    });
    
    sortedScopes.forEach((scope) => {
      this.renderScopeSection(container, scope, grouped[scope]);
    });
  }

  groupByScope(data) {
    const grouped = {};
    
    data.forEach(item => {
      if (!grouped[item.scope]) {
        grouped[item.scope] = {};
      }
      if (!grouped[item.scope][item.resource]) {
        grouped[item.scope][item.resource] = [];
      }
      grouped[item.scope][item.resource].push(item);
    });
    
    return grouped;
  }

  renderScopeSection(container, scope, resources) {
    const section = container.append('div')
      .attr('class', 'audit-scope-section');
    
    section.append('h1')
      .text(`${scope.charAt(0).toUpperCase() + scope.slice(1)}s`);
    
    // Sort resources alphabetically
    const sortedResources = Object.keys(resources).sort();
    
    sortedResources.forEach((resource) => {
      this.renderResourceSection(section, scope, resource, resources[resource]);
    });
  }

  renderResourceSection(container, scope, resource, accessList) {
    const resourceSection = container.append('div')
      .attr('class', 'audit-resource-section');
    
    resourceSection.append('h3')
      .text(`${resource}: ${accessList.length} user${accessList.length !== 1 ? 's' : ''}`);
    
    const tableContainer = resourceSection.append('div');
    
    // Sort access list by email
    const sortedAccessList = accessList.sort((a, b) => a.email.localeCompare(b.email));
    
    // Create manager for this resource with column configuration
    const manager = new AccessControlManager({
      container: tableContainer,
      message: this.message,
      scope,
      resource,
      showAddButton: false,
      showExplanations: false,
      tableClass: 'admin-table',
      columns: [
        { field: 'email', label: 'Email' },
        { field: 'parent', label: 'Granted by', render: (d) => d || '—' },
        { field: 'level', label: 'Level', editable: true },
        { field: 'actions', label: 'Actions' }
      ]
    });
    
    // Set data directly (already loaded)
    manager.data = sortedAccessList;
    
    // Render without loading
    manager.container.html('');
    const table = tableContainer.append("table").attr("class", manager.tableClass);
    manager.renderTableHeader(table);
    manager.renderTableRows(table);
  }
}